"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/cn";
import { useImageGallery } from "..";
interface GalleryImageCounterProps {
  className?: string;
  showImageName?: boolean;
}
export function GalleryImageCounter(t0) {
  const $ = _c(9);
  const {
    className,
    showImageName: t1
  } = t0;
  const showImageName = t1 === undefined ? true : t1;
  const {
    currentIndex,
    images
  } = useImageGallery();
  const currentImage = images[currentIndex];
  if (images.length <= 1) {
    return null;
  }
  let t2;
  if ($[0] !== className) {
    t2 = cn("absolute top-3 left-3 z-10 flex items-center h-6", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = currentIndex + 1;
  const t4 = showImageName && currentImage?.name && ` • ${currentImage.name}`;
  let t5;
  if ($[2] !== images.length || $[3] !== t3 || $[4] !== t4) {
    t5 = <div className="bg-black/50 backdrop-blur-sm text-white text-xs px-2 py-1 rounded-full">{t3} / {images.length}{t4}</div>;
    $[2] = images.length;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t5) {
    t6 = <div className={t2}>{t5}</div>;
    $[6] = t2;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}